var _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a6c00803-93e7-42e2-8f59-1c459692af9c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 81.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 78.4,
    width: 95,
    height: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "48.08 66.94 76.71 38.32 77.51 37.5 75.4 35.38 49 61.79 49 0 46 0 46 61.78 19.6 35.38 17.49 37.51 46.92 66.94 48.08 66.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeDownload);
export default __webpack_public_path__ + "static/media/simple filigree - download.702ac8062d89f3883146df58c30a4d90.svg";
export { ForwardRef as ReactComponent };